import React, { useState, useEffect } from 'react';
import useApiControl from '../../../common/useApiControl';
import BaseForm from '../BaseForm';
import TextField from '@mui/material/TextField';

const RegisterForm = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { data, error, loading, executeRequest } = useApiControl({
    action: '/register',
    params: { name:username, email:email, password:password },
    method: 'POST',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    executeRequest();
  };

  // Responseを監視し、トークンとユーザー情報をlocalStorageに保存する
  useEffect(() => {
    if (data) {
      const { user, token, event } = data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      // Registの場合ownerなし
      // localStorage.setItem('ownersEvent', JSON.stringify(event));
      window.location.reload();
    }
  }, [data]);

  // Errorを監視し、401 422エラーをキャッチする
  useEffect(() => {
    if (error && error.response && (error.response.status === 401 || error.response.status === 422)) {
      setPassword('');
    }
  }, [error]);

  return (
    <BaseForm onSubmit={handleSubmit} submitLabel="登録" logMessage="Register Api start" apiError={error}>
      <h3>新規登録</h3>
      <p style={{ margin: '0 0 8px', fontSize: '14px', color: '#555' }}>* は必須項目です</p>
      <TextField
        label="名前 *"
        variant="outlined"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        label="メールアドレス"
        variant="outlined"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        helperText="任意"
      />
      <TextField
        label="パスワード"
        variant="outlined"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        helperText="任意"
      />
    </BaseForm>
  );
};

export default RegisterForm;
